import { Stack, TextInput } from "@mantine/core"
import { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"

import { ManualCheckIcon } from "~/pages/Brand/Certificates/components/ManualCheckIcon"

type Props = {
  reference: string | null
  onChange: (reference: string) => void
  typeName: string
  certificateName: string | null
}

export function CertificateReference({
  reference,
  typeName,
  certificateName,
  onChange,
}: Props) {
  const { t } = useTranslation("certificates")

  const icon = useCertificateReferenceIcon({
    typeName,
    certificateName,
    reference,
  })

  return (
    <Stack>
      <TextInput
        label={t("modal.labels.reference")}
        value={reference ?? ""}
        onChange={(e) => onChange(e.currentTarget.value)}
        rightSection={icon}
      />
    </Stack>
  )
}

type useCertificateReferenceIconProps = {
  typeName: string
  certificateName: string | null
  reference: string | null
}

function useCertificateReferenceIcon({
  typeName,
  certificateName,
  reference,
}: useCertificateReferenceIconProps) {
  const [icon, setIcon] = useState<React.ReactNode>(null)

  useEffect(() => {
    if (
      (typeName.toLowerCase().includes("oeko-tex") ||
        certificateName?.toLowerCase().includes("oeko-tex")) &&
      reference
    ) {
      setIcon(<ManualCheckIcon reference={reference} />)
    } else {
      setIcon(null)
    }
  }, [typeName, certificateName, reference])

  return icon
}
